import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "v-provider" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__stats" }
const _hoisted_4 = { class: "action" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = {
  key: 0,
  class: "info"
}
const _hoisted_10 = { class: "description__footer" }

import { Plus, Trash01, Pencil02, X } from "utruckin-icons";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import { useProviderStore } from "@/features/provider/provider.store";
import { onMounted, ref } from "vue";
import { IProvider } from "@/features/provider/provider.types";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import { useNotification } from "@/utils/notification";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProviderView',
  setup(__props) {

const providerStore = useProviderStore();

const { pushNotification } = useNotification();

const loading = ref(false);
const providers = ref<IProvider[]>([]);

const modalItem = ref<any>();
const modalLoading = ref<boolean>(false);
const isModalVisible = ref<boolean>(false);
const modalType = ref<"create" | "edit">("create");

const getList = async () => {
  await providerStore.getList(loading, (res: any) => {
    if (res) {
      providers.value = res;
    }
  });
};

const closeModal = () => {
  modalItem.value = {};
  isModalVisible.value = false;
  modalLoading.value = false;
};

const saveModal = async () => {
  if (modalType.value == "create") {
    if (
      !modalItem.value.name ||
      !modalItem.value.app_name ||
      !modalItem.value.api_token
    )
      return;

    const organizationId: string = localStorage.getItem(
      "organizationId"
    ) as string;
    if (!organizationId) router.push("/organization");

    await providerStore.createProvider(
      {
        organization_id: organizationId,
        name: modalItem.value.name,
        app_name: modalItem.value.app_name,
        api_token: modalItem.value.api_token,
        is_active: true,
      },
      modalLoading,
      async (data: any) => {
        if (data) {
          pushNotification("Successfully created", "success");
          closeModal();
          await getList();
        }
      }
    );
  } else {
    if (!modalItem.value.name || !modalItem.value.app_name) return;

    await providerStore.updateProvider(
      {
        name: modalItem.value.name,
        app_name: modalItem.value.app_name,
        is_active: true,
      },
      modalItem.value.id,
      modalLoading,
      async (data: any) => {
        if (data) {
          pushNotification("Successfully saved", "success");
          closeModal();
          await getList();
        }
      }
    );
  }
};

const openModal = (type: "create" | "edit", item?: any) => {
  if (type == "create") {
    modalItem.value = {
      name: "",
      app_name: "",
      api_token: "",
      is_active: true,
    };
    modalType.value = "create";
  } else {
    modalItem.value = item;
    modalType.value = "edit";
  }
  modalLoading.value = false;
  isModalVisible.value = true;
};

const turnOff = async (item: any) => {
  const payload = {
    name: item.name,
    app_name: item.app_name,
    is_active: false,
  };
  await providerStore.updateProvider(
    payload,
    item.id,
    loading,
    async (data: any) => {
      if (data) {
        pushNotification("Successfully made inactive", "success");
        await getList();
      }
    }
  );
};

onMounted(async () => {
  await getList();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CommonButton, {
          type: "primary",
          label: "Add provider",
          prepend: "",
          prependIcon: _unref(Plus),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal('create')))
        }, null, 8, ["prependIcon"])
      ])
    ]),
    _createVNode(CommonTable, {
      headers: _unref(providerStore).providerHeaders,
      loading: loading.value,
      items: providers.value
    }, {
      id: _withCtx(({ index }) => [
        _createElementVNode("span", null, _toDisplayString(index + 1), 1)
      ]),
      token: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createTextVNode(" ******************", -1)
      ]))]),
      status: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["status", item.is_active ? '' : 'inactive'])
        }, _toDisplayString(item.is_active ? "active" : "inactive"), 3)
      ]),
      actions: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "action__item",
            onClick: ($event: any) => (openModal('edit', item))
          }, [
            _createVNode(_unref(Pencil02), { size: 18 })
          ], 8, _hoisted_5)), [
            [_directive_tooltip, {
              content: 'Edit',
              html: true,
            }]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "action__item",
            onClick: ($event: any) => (turnOff(item))
          }, [
            _createVNode(_unref(Trash01), { size: 18 })
          ], 8, _hoisted_6)), [
            [_directive_tooltip, {
              content: 'Make Inactive',
              html: true,
            }]
          ])
        ])
      ]),
      _: 1
    }, 8, ["headers", "loading", "items"]),
    _createVNode(CommonModal, {
      modelValue: isModalVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isModalVisible).value = $event)),
      title: modalType.value == 'create' ? 'Add a provider' : 'Edit a provider',
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: closeModal
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveModal
          })
        ])
      ]),
      default: _withCtx(() => [
        (modalItem.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(CommonInput, {
                  modelValue: modalItem.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modalItem.value.name) = $event)),
                  label: "Name"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(CommonInput, {
                  modelValue: modalItem.value.app_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modalItem.value.app_name) = $event)),
                  label: "App name"
                }, null, 8, ["modelValue"])
              ]),
              (modalType.value == 'create')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(CommonInput, {
                      modelValue: modalItem.value.api_token,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modalItem.value.api_token) = $event)),
                      label: "Token"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})